/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

import { PriceVersions } from "App/IOC/Services";

export default {
    FindByPrice: PriceVersions.FindByPrice,
    Publish: PriceVersions.Publish,
    Revise: PriceVersions.Revise
};
